<template>
  <div>
    <h5 class="mb-2">
      {{ dataComponent.name }}
    </h5>

    <b-row class="mt-3">
      <b-col
        md="5"
        sm="12"
        cols="12"
      >
        <b-form-group>
          <b-row class="mx-0 w-full">
            <b-col
              class="pl-0"
              md="6"
              sm="6"
            >
              <label>Project</label>
            </b-col>
            <b-col
              class="pr-0 text-right"
              md="6"
              sm="6"
            >
              <label
                style="color: #4a90e2"
                class="select-label mr-2"
              >
                Select All
              </label>
              <label
                style="color: #4a90e2"
                class="select-label"
              >
                Unselect All
              </label>
            </b-col>
          </b-row>
          <j-multi-select
            :disabled="true"
            placeholder="Select Project"
            value-format="object"
            label="name"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="5"
        sm="12"
        cols="12"
      >
        <b-form-group>
          <b-row>
            <b-col
              cols="12"
              md="12"
            >
              <b-row>
                <b-col
                  cols="6"
                  md="6"
                >
                  <label for="startDate">From</label>
                  <j-datepicker
                    :disabled="true"
                    format="MMM dd, yyyy"
                    placeholder="Ex. Jan 01, 2019"
                  />
                </b-col>
                <b-col
                  cols="6"
                  md="6"
                >
                  <b-form-group>
                    <label for="endDate">To</label>
                    <j-datepicker
                      :disabled="true"
                      format="MMM dd, yyyy"
                      placeholder="Ex. Des 31, 2019"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col
        class="d-flex align-items-center "
        md="2"
        sm="12"
        cols="3"
      >
        <b-form-group class="text-left search-form">
          <b-row>
            <b-col
              cols="10"
              md="10"
            >
              <b-button class="btn blue d-flex items-center">
                <i class="fa fa-search bold mr-1 mt-1" /> Search
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Columns -->
    <div class="columns mt-3">
      <div class="d-flex align-items-center">
        <div
          v-for="column in columns"
          :key="column"
          class="column"
        >
          <div
            class="header-list"
            style="cursor: default !important;"
          >
            <div class="column-name">{{ column }}</div>
          </div>
          <div
            v-for="index in 4"
            :key="index"
            :class="{'bg-gray': index === 2 || index === 4}"
            class="column-preview"
            style="cursor: default !important;"
          >
            <div class="content-preview"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      columns: [
        'PHOTO',
        'SHIFT START TIME',
        'CHECK IN DATE',
        'SHIFT END TIME',
        'CHECK OUT DATE',
        'PROJECT',
        'ADDRESS',
        'VENUE',
        'TOTAL WORKING HOURS',
        'STATUS',
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dummy/DummyAttendanceMyLog.vue